import React, { useRef, useState } from "react";
import FormControl from "@mui/joy/FormControl";
import FormLabel from "@mui/joy/FormLabel";
import Input from "@mui/joy/Input";
import Stack from "@mui/joy/Stack";
import CardActions from "@mui/joy/CardActions";
import CardOverflow from "@mui/joy/CardOverflow";
import "react-international-phone/style.css";
import { Button } from "primereact/button";
import { add, update } from "../../service/equipmentTypesService";
import { Grid } from "@mui/material";
import IntervalDropdown from "../../components/IntervalDropdown";
import MultiDropdownApi from "../../components/MultiDropdownApi";
import { TabPanel, TabView } from "primereact/tabview";
import { InputText } from "primereact/inputtext";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import {
  chemicalTypeAdd,
  chemicalTypeUpdate,
} from "../../service/chemicalTypesService";
import { FREQUENCIES } from "../forms-allocation/constants";
import { Dropdown } from "primereact/dropdown";
import DropdownApi from "../../components/DropdownApi";
export default function ChemicalTypeAdd(modalProps: any) {
  const details = modalProps?.details;

  const [name, setName] = useState(details?.name || "");
  const [nameError, setNameError] = useState(false);

  const [safeChemicalChecklist, setSafeChemicalChecklist] = useState(
    details?.chemical_safe_checklist || [""]
  );

  const [riskChemicalChecklist, setRiskChemicalChecklist] = useState(
    details?.chemical_risk_checklist || [""]
  );

  const [hazard, setHazard] = useState(
    details?.hazard || ""
  );

  const [appointment, setAppointment] = useState(
    details?.appointment || ""
  );

  const [frequency, setFrequency] = useState(details?.frequency || 1);

  const [safeWorkMethod, setSafeWorkMethod] = useState(
    details?.safe_work_method || ""
  );

  const [relevantAppointment, setRelevantAppointment] = useState(
    details?.relevant_appointment || []
  );

  async function addIndustry() {
    setNameError(!name || name === "");
    if (!name || name === "") {
      modalProps.toast.current.show({
        severity: "warn",
        summary: "Please enter all required fields",
        life: 3000,
      });
      return;
    }
    const updateDetails = {
      name,
      hazard,
      chemical_safe_checklist: safeChemicalChecklist,
      chemical_risk_checklist: riskChemicalChecklist,
      frequency,
      appointment,
      safe_work_method: safeWorkMethod,
      relevant_appointment: relevantAppointment,
    };
    if (modalProps.id) {
      chemicalTypeUpdate(modalProps.id, updateDetails).then((r: any) => {
        modalProps.toast.current.show({
          severity: "success",
          summary: "Chemical Type Updated Successfully",
          life: 3000,
        });
        modalProps.setVisible(false);
        modalProps.setGlobalLoading(false);
        modalProps.setReload(!modalProps.reload);
      });
    } else {
      chemicalTypeAdd(updateDetails).then((r: any) => {
        modalProps.toast.current.show({
          severity: "success",
          summary: "Chemical Type Created Successfully",
          life: 3000,
        });
        modalProps.setVisible(false);
        modalProps.setGlobalLoading(false);
        modalProps.setReload(!modalProps.reload);
      });
    }
  }

  return (
    <React.Fragment>
      <TabView>
        <TabPanel header="Details">
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <FormControl
                error={nameError}
                sx={{ display: { sm: "flex-column", md: "flex-row" } }}
              >
                <FormLabel>
                  Chemical Type<div style={{ color: "red" }}>*</div>
                </FormLabel>
                <Input
                  value={name}
                  size="sm"
                  placeholder="Chemical Type"
                  onChange={(e) => setName(e.target.value)}
                />
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <MultiDropdownApi
                apiPath="risk-hazard"
                optionLabel="name"
                optionValue="id"
                label="Hazard"
                selectedData={hazard}
                setSelectedData={setHazard}
              />
            </Grid>
            <Grid item xs={6}>
              <FormControl
                sx={{ display: { sm: "flex-column", md: "flex-row" } }}
              >
                <FormLabel>Checklist Frequency in days</FormLabel>
                <InputText
                  value={frequency}
                  onChange={(e) => setFrequency(e.target.value)}
                  type="number"
                />
              </FormControl>
            </Grid>
            <Grid item xs={6}>
              <DropdownApi
                apiPath="appointments"
                optionLabel="name"
                optionValue="id"
                label="Checklist Appointment"
                selectedData={appointment}
                setSelectedData={setAppointment}
              />
            </Grid>
            <Grid item xs={12}>
              <MultiDropdownApi
                apiPath="appointments"
                optionLabel="name"
                optionValue="id"
                label="Relevant Appointments"
                selectedData={relevantAppointment}
                setSelectedData={setRelevantAppointment}
              />
            </Grid>
            <Grid item xs={12}>
              <DropdownApi apiPath='safe-work-method' optionLabel="name" optionValue='id' label='Safe Work Method' selectedData={safeWorkMethod} setSelectedData={setSafeWorkMethod} />
            </Grid>
          </Grid>
        </TabPanel>
        <TabPanel header="Checklist">
          <TabView>
            <TabPanel header="Safe">
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <FormControl
                    sx={{ display: { sm: "flex-column", md: "flex-row" } }}
                  >
                    <FormLabel>Questions</FormLabel>
                    <Button
                      type="button"
                      icon="pi pi-plus"
                      label="Add"
                      className="p-button-outlined"
                      size="small"
                      style={{
                        position: "absolute",
                        right: 0,
                        padding: 10,
                        marginTop: -15,
                      }}
                      onClick={() => {
                        const updatedChecklist = [...safeChemicalChecklist];
                        updatedChecklist.push("");
                        setSafeChemicalChecklist(updatedChecklist);
                      }}
                    />
                  </FormControl>
                </Grid>
                {safeChemicalChecklist.map((checklist: any, index: number) => {
                  return (
                    <Grid item xs={12} key={index}>
                      <IconField>
                        <InputIcon
                          className="pi pi-trash"
                          style={{ color: "#eb445a" }}
                          onClick={() => {
                            const updatedChecklist = [...safeChemicalChecklist];
                            updatedChecklist.splice(index, 1);
                            setSafeChemicalChecklist(updatedChecklist);
                          }}
                        >
                          {" "}
                        </InputIcon>
                        <InputText
                          value={checklist}
                          onChange={(e) => {
                            const updatedChecklist = [...safeChemicalChecklist];
                            updatedChecklist[index] = e.target.value;
                            setSafeChemicalChecklist(updatedChecklist);
                          }}
                          style={{ width: "100%" }}
                          type="text"
                          className="p-inputtext-sm PrimeSmallInput"
                          placeholder={`Please enter question ${index + 1}`}
                        />
                      </IconField>
                    </Grid>
                  );
                })}
              </Grid>
            </TabPanel>
            <TabPanel header="At Risk">
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <FormControl
                    sx={{ display: { sm: "flex-column", md: "flex-row" } }}
                  >
                    <FormLabel>Questions</FormLabel>
                    <Button
                      type="button"
                      icon="pi pi-plus"
                      label="Add"
                      className="p-button-outlined"
                      size="small"
                      style={{
                        position: "absolute",
                        right: 0,
                        padding: 10,
                        marginTop: -15,
                      }}
                      onClick={() => {
                        const updatedChecklist = [...riskChemicalChecklist];
                        updatedChecklist.push("");
                        setRiskChemicalChecklist(updatedChecklist);
                      }}
                    />
                  </FormControl>
                </Grid>
                {riskChemicalChecklist.map((checklist: any, index: number) => {
                  return (
                    <Grid item xs={12} key={index}>
                      <IconField>
                        <InputIcon
                          className="pi pi-trash"
                          style={{ color: "#eb445a" }}
                          onClick={() => {
                            const updatedChecklist = [...riskChemicalChecklist];
                            updatedChecklist.splice(index, 1);
                            setRiskChemicalChecklist(updatedChecklist);
                          }}
                        >
                          {" "}
                        </InputIcon>
                        <InputText
                          value={checklist}
                          onChange={(e) => {
                            const updatedChecklist = [...riskChemicalChecklist];
                            updatedChecklist[index] = e.target.value;
                            setRiskChemicalChecklist(updatedChecklist);
                          }}
                          style={{ width: "100%" }}
                          type="text"
                          className="p-inputtext-sm PrimeSmallInput"
                          placeholder={`Please enter question ${index + 1}`}
                        />
                      </IconField>
                    </Grid>
                  );
                })}
              </Grid>
            </TabPanel>
          </TabView>
        </TabPanel>
      </TabView>
      <br />
      <br />
      <CardOverflow
        style={{ width: "100%" }}
        sx={{ borderTop: "1px solid", borderColor: "divider" }}
      >
        <CardActions
          style={{ marginTop: 15 }}
          sx={{ alignSelf: "flex-end", pt: 2 }}
        >
          <Button
            name="button"
            icon="pi pi-save"
            label="Save"
            className="p-button-outlined"
            size="small"
            style={{
              position: "absolute",
              fontSize: "small",
              right: 0,
              color: "#2dd36f",
            }}
            onClick={() => addIndustry()}
          />
        </CardActions>
      </CardOverflow>
    </React.Fragment>
  );
}
